<customer-portal-revolution-main-view></customer-portal-revolution-main-view>
<customer-portal-ef-spinner-dialog
  *ngIf="showTransifexSpinner"
></customer-portal-ef-spinner-dialog>
